<template>
  <v-row>
    <v-col cols="12" v-if="triggerImplementation.eventableType === 'EventImplementation'">
      <local-id-field
          label="トリガとなるイベント実装名"
          :value="triggerImplementation.eventableLocalId">
        <template #prepend>
          <v-icon>mdi-lightning-bolt</v-icon>
        </template>
      </local-id-field>
    </v-col>
    <v-col cols="12" v-if="triggerImplementation.eventableType === 'CalendarImplementation'">
      <text-field-like
          label="カレンダ名"
          v-model="triggerImplementation.eventableName">
        <template #prepend>
          <v-icon>mdi-calendar</v-icon>
        </template>
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <text-field-like
          :value="triggerImplementation.eventableDescription"
          label="説明"
          placeholder="未設定"
          multi-line
          hide-details>
        <template #prepend>
          <v-icon style="visibility: hidden;">mdi-arrow-right</v-icon>
        </template>
      </text-field-like>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import LocalIdField from "@/components/molecules/LocalIdField.vue";
export default {
  name: 'TriggerImplementationDeleteForm',
  components: {LocalIdField, TextFieldLike},
  model: {
    prop: 'triggerImplementation',
    event: 'change-form'
  },
  props: {
    triggerImplementation: {
      type: Object,
      required: true
    }
  }
}
</script>
